import { render, staticRenderFns } from "./ProductGroupLabel.vue?vue&type=template&id=2d755cca&"
import script from "./ProductGroupLabel.vue?vue&type=script&lang=ts&"
export * from "./ProductGroupLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports